export default function(pointA, pointB) {
  return pointA[0] === pointB[0] && pointA[1] === pointB[1];
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/topojson-server/src/hash/point-equal.js
// module id = ../../../../topojson-server/src/hash/point-equal.js
// module chunks = vendor